export default {
  LIVE_STREAMING_INFO_LIST_REQUEST: 'APP/LIVE_STREAMING_INFO/LIVE_STREAMING_INFO_LIST_REQUEST',
  LIVE_STREAMING_INFO_LIST_SUCCESS: 'APP/LIVE_STREAMING_INFO/LIVE_STREAMING_INFO_LIST_SUCCESS',
  LIVE_STREAMING_INFO_LIST_ERROR: 'APP/LIVE_STREAMING_INFO/LIVE_STREAMING_INFO_LIST_ERROR',
};
